/*@ngInject*/
const BaseSharedPromiseRepository = function ($http, $q) {

    this.getGETSharedPromiseCache = function () {
        return null;
    };

    this.getPOSTSharedPromiseCache = function () {
        return null;
    };

    this.getDELETESharedPromiseCache = function () {
        return null;
    };

    this.get = function (cacheKey, url, config) {
        let defer;

        function onSuccess(response) {
            if (response) {
                defer.resolve(this.processGetResponseData(_.cloneDeep(response.data)));
            } else {
                defer.reject();
            }
        }

        function onError(errorResponse) {
            return defer.reject(errorResponse.data);
        }

        function onFinally() {
            this.getGETSharedPromiseCache()[cacheKey] = null;
            delete this.getGETSharedPromiseCache()[cacheKey];
        }

        if (_.has(this.getGETSharedPromiseCache(), cacheKey)) {
            return _.get(this.getGETSharedPromiseCache(), cacheKey);
        }

        defer = $q.defer();

        $http.get(url, config).then(onSuccess.bind(this), onError).finally(onFinally.bind(this));

        this.getGETSharedPromiseCache()[cacheKey] = defer.promise;

        return defer.promise;
    };

    this.processGetResponseData = function (responseData) {
        return responseData;
    };

    this.delete = function (cacheKey, url) {
        let defer;

        function onSuccess(response) {
            if (response) {
                defer.resolve(this.processDeleteResponseData(_.cloneDeep(response.data)));
            } else {
                defer.reject();
            }
        }

        function onError(errorResponse) {
            return defer.reject(errorResponse.data);
        }

        function onFinally() {
            this.getDELETESharedPromiseCache()[cacheKey] = null;
            delete this.getDELETESharedPromiseCache()[cacheKey];
        }

        if (_.has(this.getDELETESharedPromiseCache(), cacheKey)) {
            return _.get(this.getDELETESharedPromiseCache(), cacheKey);
        }

        defer = $q.defer();

        $http.delete(url).then(onSuccess.bind(this), onError).finally(onFinally.bind(this));

        this.getDELETESharedPromiseCache()[cacheKey] = defer.promise;

        return defer.promise;
    };

    this.processDeleteResponseData = function (responseData) {
        return responseData;
    };

    this.post = function (cacheKey, url, formData, config) {
        let defer;

        function onSuccess(response) {
            if (response) {
                defer.resolve(this.processPostResponseData(_.cloneDeep(response.data)));
            } else {
                defer.reject();
            }
        }

        function onError(errorResponse) {
            return defer.reject(errorResponse.data);
        }

        function onFinally() {
            this.getPOSTSharedPromiseCache()[cacheKey] = null;
            delete this.getPOSTSharedPromiseCache()[cacheKey];
        }

        if (_.has(this.getPOSTSharedPromiseCache(), cacheKey)) {
            return _.get(this.getPOSTSharedPromiseCache(), cacheKey);
        }

        defer = $q.defer();

        $http.post(url, formData, config).then(onSuccess.bind(this), onError).finally(onFinally.bind(this));

        this.getPOSTSharedPromiseCache()[cacheKey] = defer.promise;

        return defer.promise;
    };

    this.processPostResponseData = function (responseData) {
        return responseData;
    };
};

angular.module('umCore')
    .service('baseSharedPromiseRepository', BaseSharedPromiseRepository);
